import { Flex, Text } from "@chakra-ui/react"
import React from "react"

// Note: the background color of the Page is unset, because the <body> should set it instead.
export const Page: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Flex
      flexDirection="column"
      gap={10}
      p={10}
      w="100%"
      sx={{
        "--layout-page-content-max-width": "75rem",
      }}
      maxW="var(--layout-page-content-max-width)"
    >
      {children}
    </Flex>
  )
}

type PageSpacingRowProps = {
  startSlot?: React.ReactNode
  endSlot?: React.ReactNode
}

export const PageSpacingRow: React.FC<
  React.PropsWithChildren<PageSpacingRowProps>
> = ({ startSlot, endSlot }) => {
  return (
    <Flex w="100%" justifyContent="space-between" alignItems="stretch" gap={4}>
      <Flex minH={10} alignItems="center">
        {startSlot}
      </Flex>
      {endSlot && (
        // We use a fixed height here to keep the endSlot controls top-aligned when the title wraps
        // (but they're still centered with the title when it's on one line)
        <Flex alignItems="center" gap={2} h={10} flexShrink={0}>
          {endSlot}
        </Flex>
      )}
    </Flex>
  )
}

export const PageTitle: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <Text as="h1" textStyle="ds.display.headline" color="ds.text.brand">
      {children}
    </Text>
  )
}
